import { Injectable } from '@angular/core';

// Import Service:
import { ObjetoSomaEntity } from '../servicio-soma.service';

@Injectable({
  providedIn: 'root'
})
export class GenerarTxtSomaService {

  private fechaImpresion: Date = new Date();

  constructor() { }

  private getGenerarDataTxt( arrayData: ObjetoSomaEntity[] ): string {
    let response = '';

    if ( arrayData != null ) {
      arrayData.forEach( objeto => {
        response +=
          objeto.tipoIdentificacion + '|' +
          objeto.numeroIdentifiacion + '|' +
          objeto.diagnosticoPrincipal + '|' +
          objeto.diagnosticoRelacionado + '|' +
          objeto.fechaPrestacionServicio + '|' +
          objeto.codigoActividad + '|' +
          objeto.descripcionActividad + '|' +
          objeto.ambitoPrestacion + '|' +
          objeto.formaReconocimiento + '|' +
          objeto.numeroDiasEstancia + '|' +
          objeto.valorActividad + '|' +
          objeto.valorCuotaModeradora + '|' +
          objeto.valorCopago + '|' +
          objeto.tipoCodificacion + '|' +
          objeto.numeroFactura + '|' +
          objeto.periodoDuracion + '|' +
          objeto.fechaSolicitudServicio + '|' +
          objeto.fechaSolicitudMedica + '|' +
          objeto.plan + '|' +
          objeto.peydt;
      });
    }

    return response;
  }

  private getGenerarDataTxtByComas( arrayData: ObjetoSomaEntity[] ): string {
    let response = '';

    if ( arrayData != null ) {
      arrayData.forEach( objeto => {
        response +=
          objeto.tipoIdentificacion + '|' +
          objeto.numeroIdentifiacion + '|' +
          objeto.diagnosticoPrincipal + '|' +
          objeto.diagnosticoRelacionado + '|' +
          objeto.fechaPrestacionServicio + '|' +
          objeto.codigoActividad + '|' +
          objeto.descripcionActividad + '|' +
          objeto.ambitoPrestacion + '|' +
          objeto.formaReconocimiento + '|' +
          objeto.numeroDiasEstancia + '|' +
          objeto.valorActividad + '|' +
          objeto.valorCuotaModeradora + '|' +
          objeto.valorCopago + '|' +
          objeto.tipoCodificacion + '|' +
          objeto.numeroFactura + '|' +
          objeto.periodoDuracion + '|' +
          objeto.fechaSolicitudServicio + '|' +
          objeto.fechaSolicitudMedica + '|' +
          objeto.plan + '|' +
          objeto.peydt;
      });
    }

    return response;
  }

  public generarText( arrayData: ObjetoSomaEntity[] ) {

    const resultParseo = this.getGenerarDataTxt( arrayData );
    const archivo = `Reporte_Soma_${ this.fechaImpresion.toLocaleDateString() }`;
    const type = 'text/plain;charset=utf-8';
    const a = document.createElement('a'), file = new Blob([resultParseo], { type : type });

    if ( window.navigator.msSaveOrOpenBlob ) {

        window.navigator.msSaveOrOpenBlob(file, archivo);

    } else {

      if ( resultParseo !== '' ) {

        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = archivo;
        document.body.appendChild(a);
        a.click();

        setTimeout(
            function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
        0);

      }
    }
  }

  public generarTextByComas( arrayData: ObjetoSomaEntity[] ) {

    const resultParseo = this.getGenerarDataTxtByComas( arrayData );
    const archivo = `Reporte_Soma_${ this.fechaImpresion.toLocaleDateString() }`;
    const type = 'text/plain;charset=utf-8';
    const a = document.createElement('a'), file = new Blob([resultParseo], { type : type });

    if ( window.navigator.msSaveOrOpenBlob ) {

        window.navigator.msSaveOrOpenBlob(file, archivo);

    } else {

      if ( resultParseo !== '' ) {

        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = archivo;
        document.body.appendChild(a);
        a.click();

        setTimeout(
            function() {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
        0);

      }
    }
  }

}
